import sidebarItems from 'config/sidebarItems'
import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'
import { hasFeatureSome } from '../../utils/features'

const PENDENCY_TYPES = {
  CLARIFICATIONS: 'Clarifications',
  INFORMATIONS: 'Informations',
  REGISTER: 'Register',
  SFP: 'Sfp',
  SUITABILITY: 'Suitability',
  TERM: 'Term',
  UPDATE_REGISTRY: 'UpdateRegistry',
  UPLOAD: 'Upload'
}

const PENDENCY_STATUS = {
  PENDING: 'Pending',
  ANALYZE: 'Analyze'
}

const FEATURE_ALLOW_RESIDENTIAL_UPDATE = 'inv_1app_sunset_allow_residential_update'
const FEATURE_SUNSET_EARNINGS = 'inv_1app_sunset_earnings_web'
// const FEATURE_NO_TED = 'inv_1app_sunset_total_sunset_inert_no_ted'
// const FEATURE_REMOVE_EASYTOKEN = 'inv_1app_sunset_total_sunset_remove_easytoken'

const enhancer = compose(
  connect(({ featureToggle }) => ({ featureToggle })),
  withProps(({ pendency: { fetched, status, pendencies }, featureToggle }) => ({
    hasRegisterPendency:
      status === PENDENCY_STATUS.PENDING && pendencies[0].type === PENDENCY_TYPES.REGISTER,
    isLoading: !fetched,
    hasFeatureToggleCustody: true,
    hasFeatureToggleEarnings: !hasFeatureSome(FEATURE_SUNSET_EARNINGS,
      featureToggle.data ? featureToggle.data : []),
    allowResidentialUpdate: hasFeatureSome(FEATURE_ALLOW_RESIDENTIAL_UPDATE,
      featureToggle.data ? featureToggle.data : []),
    noTed: true,
    hasFeatureRemoveEasytoken: true
  })),
  withProps(({
    isMobile,
    hasRegisterPendency,
    hasFeatureToggleCustody,
    hasFeatureToggleEarnings,
    allowResidentialUpdate,
    hasFeatureRemoveEasytoken,
    noTed
  }) => ({
    items: sidebarItems(
      isMobile,
      hasRegisterPendency,
      hasFeatureToggleCustody,
      hasFeatureToggleEarnings,
      allowResidentialUpdate,
      hasFeatureRemoveEasytoken,
      noTed
    )
  }))
)

export default enhancer
